import { createFileRoute, Outlet } from '@tanstack/react-router'
import { supplierReturnQueryOptions } from '../../../../features/purchasing/queries'

export const Route = createFileRoute('/_app/supplier-returns/$returnId')({
  staticData: { crumb: 'supplierReturn' },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(supplierReturnQueryOptions(params.returnId)),
  component: Outlet,
})
